const outlookLang = {

}

const communicationLang = {
  senders: {
    type: {
      outlook: 'Outlook'
    }
  }
}

export default {
  outlook: outlookLang,
  communication: communicationLang
}
